<template>
  <div>
    <!-- 范围 -->
    <div
      class="role-select"
      :class="{'no-role-select': !formateRangeDatasStatus}"
    >
      <range
        :class="{'fixed-c' : fixed}"
        type="rec"
        @handleRange="handleRangeRec"
      />
    </div>
    <!-- 概览 -->
    <date-select
      ref="revOverViewRef"
      :content-title="overviewContentTitle"
      :date-data="overviewData"
      :default-select-index="defaultOverviewIndex"
      @callbackEvent="handleCallbackEvent"
      @dateTimeChange="handleDateChangeRec"
    />
    <div class="view-content-parent">
      <div
        v-for="(item,index) in devRecOverViewDatas"
        :key="index"
        :style="{width: viewContentChildrenWidth}"
        class="view-content-children"
      >
        <p>{{ item.name }}</p>
        <p><span>{{ item.num }}</span></p>
      </div>
    </div>
    <!-- 趋势 -->
    <div>
      <date-select
        ref="revTendencyRef"
        :content-title="tendencyTitle"
        :date-data="overviewTendency"
        :select-status="selectStatus"
        :default-select-index="defaultTendencyDateIndex"
        @callbackEvent="handleCallbackTendencyEvent"
        @level-change="handleLevelChange"
        @dateTimeChange="handleDateChangeTendency"
      />
      <div class="margin-bottom-40">
        <HChart
          :id="tendencyId"
          ref="tendencyRef"
          :option="tendencyOption"
        />
      </div>
    </div>
    <!-- 数据 -->
    <div>
      <date-select
        v-if="receptionType === 'createSta'"
        ref="revTableDataRef"
        :content-title="dataTitle"
        :date-data="dataDateData"
        :select-from-info-status="true"
        :type-select-status="true"
        :type-default="developerTypeDefault"
        :default-select-index="defaultDataSelectIndex"
        @callbackEvent="handleCallbackDataEvent"
        @dateTimeChange="handleDateChangeTableData"
        @typeChange="handleTypeChangeTableData"
        @handleFromChange="handleFromChange"
      />
      <date-select
        v-if="receptionType === 'auditSta'"
        ref="revTableDataRef"
        :content-title="dataTitle"
        :date-data="dataDateData"
        :type-select-status="true"
        :type-default="developerTypeDefault"
        :default-select-index="defaultDataSelectIndex"
        @callbackEvent="handleCallbackDataEvent"
        @dateTimeChange="handleDateChangeTableData"
        @typeChange="handleTypeChangeTableData"
      />

      <table-data
        class="margin-top-24  margin-bottom-40"
        :table-data="tableData"
        :columns="tableColumns"
        :time="detailTimeData"
        :pagination="isShowPagination"
        type="rec"
        @changeParams="handleChangeParams"
      />
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-css"
    />
  </div>
</template>
<script>
import DateSelect from './DateSelectComponent.vue'
import TableData from './TableData.vue'
import Range from './Range.vue'
import HChart from '@/components/pc/HighChart.vue'
import { highchartLineOption } from '@/lib/chart-option'
import { overviewTendency, overviewData } from '@/lib/statistic-utils.js'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    DateSelect,
    HChart,
    TableData,
    Range
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowPagination: false,
      tableColumns: [],
      tableData: [],
      tendencyDataList: [],
      tablecolumnsArray: [],
      dataTitle: this.$t('message["1130"]'),
      defaultDataSelectIndex: 3,
      dataDateData: overviewData,
      tendencyId: 'tendencyId',
      tendencyOption: highchartLineOption(),
      selectStatus: true,
      tendencyTitle: this.$t('message["895"]'),
      defaultTendencyDateIndex: 2,
      overviewTendency: overviewTendency,
      overviewContentTitle: this.$t('message["346"]'),
      defaultOverviewIndex: 3,
      overviewData: overviewData,
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      tendencyTimeData: { timetype: 6 },
      levelValue: 0,
      // 数据类型默认值
      developerTypeDefault: 0,
      fixed: false
    }
  },
  computed: {
    ...mapState('statistic', ['devRecOverViewDatas', 'tendencyDataArray', 'recTablesDetailDatas', 'loadingContent', 'receptionType', 'formateRangeDatasStatus']),
    viewContentChildrenWidth () {
      let count = this.devRecOverViewDatas.length
      return parseInt(((1040 - (count - 1) * 20) / count)) + 'px'
    }
  },
  watch: {
    tendencyDataArray (val) {
      if (!val) return
      this.tendencyDataList = this.formateTendencyData(val)
      this.drawLine()
      document.title = `${this.$t('message["1368"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    recTablesDetailDatas (val) {
      if (!val) return
      this.tableColumns = this.formateTableColmunsData(val.config)
      this.tableData = this.formateTableDatas(val.data)
      if (val.total) {
        this.tableData = this.tableData.concat(this.formateTableDatas(val.total, 'total', val.maxPage))
      }
      if (val.count) {
        this.isShowPagination = true
      } else {
        this.isShowPagination = false
      }
    }
  },
  mounted () {
    this.fetchGetRecOverView(this.overviewTimeData)
    this.fetchGetRTendencyDatas(this.tendencyTimeData)
    this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
    this.fetchStaticTypes()
    this.getDetailRecFromInfoPcDatas()
    if (this.tendencyDataArray.length > 0) {
      this.tendencyDataList = this.formateTendencyData(this.tendencyDataArray)
      this.drawLine()
    }
    this.setTabNavStyle()
    window.addEventListener('resize', this.setTabNavStyle)
    document.addEventListener('scroll', this.setTabNavStyle)
  },
  methods: {
    ...mapActions('statistic', ['fetchGetRecOverView', 'fetchGetRTendencyDatas', 'fetchGetRecDetailTableDatas', 'fetchStaticTypes', 'getDetailRecFromInfoPcDatas']),
    ...mapMutations('statistic', ['setIsTablePShow']),
    drawLine () {
      this.$refs.tendencyRef.chartObj.series[0].update({
        name: this.$t('message["1376"]'),
        data: this.tendencyDataList.data
      })
      let isNull = this.tendencyDataList.data.every(item => item === 0)
      this.$refs.tendencyRef.chartObj.yAxis[0].setExtremes(0, isNull ? 10 : null)
      this.$refs.tendencyRef.chartObj.xAxis[0].setCategories(this.tendencyDataList.category)
    },
    handleChangeParams (value) {
      if (!value) return
      const { roleid } = this.detailTimeData
      if (roleid === '0') {
        delete value.roleid
        delete value.userid
        delete value.groupid
      }
      this.detailTimeData = Object.assign(this.detailTimeData, value)
    },
    formateTendencyData (array) {
      const valueJson = {
        category: [],
        data: []
      }
      array.map(value => {
        valueJson.category.push(value.name)
        valueJson.data.push(value.num)
      })
      return valueJson
    },
    formateTableColmunsData (array) {
      let tempArray = []
      this.tablecolumnsArray = []
      if (Array.isArray(array)) {
        array.map(value => {
          this.tablecolumnsArray.push(value.sortId)
          if (value.options) {
            this.tableConfigOptions = Object.values(value.options)
          }
          // if (value.sortable) {
          //   if (value.sortId === 'rank') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'rank' },
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId],
          //       width: 60
          //     })
          //   } else if (value.sortId === 'audit') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'audit' },
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId],
          //       width: 160
          //     })
          //   } else if (value.sortId === 'name') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'name' },
          //       filters: this.formateFilter(value.options),
          //       filterMultiple: false,
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId],
          //       width: 140
          //     })
          //   } else if (value.sortId === 'rectype') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: {
          //         customRender: 'rectype',
          //         filterDropdown: 'filterDropdown'
          //       },
          //       onFilterDropdownVisibleChange: visible => {
          //         if (visible) {
          //           this.setIsTablePShow(true)
          //         } else {
          //           this.setIsTablePShow(false)
          //         }
          //       },
          //       width: 160,
          //       ellipsis: true
          //     })
          //   } else {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId]
          //     })
          //   }
          // } else {
          //   if (value.sortId === 'rank') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'rank' },
          //       width: 60
          //     })
          //   } else if (value.sortId === 'audit') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'audit' },
          //       width: 160
          //     })
          //   } else if (value.sortId === 'name') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       filters: this.formateFilter(value.options),
          //       filterMultiple: false,
          //       scopedSlots: { customRender: 'name' },
          //       width: 140
          //     })
          //   } else if (value.sortId === 'rectype') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: {
          //         customRender: 'rectype',
          //         filterDropdown: 'filterDropdown'
          //       },
          //       onFilterDropdownVisibleChange: visible => {
          //         if (visible) {
          //           this.setIsTablePShow(true)
          //         } else {
          //           this.setIsTablePShow(false)
          //         }
          //       },
          //       width: 160,
          //       ellipsis: true
          //     })
          //   } else {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId
          //     })
          //   }
          // }
          if (value.sortId === 'rank') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: { customRender: 'rank' },
              width: 60
            })
          } else if (value.sortId === 'audit') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: { customRender: 'audit' },
              width: 160
            })
          } else if (value.sortId === 'name') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              options: this.formateFilter(value.options),
              // filterMultiple: false,
              scopedSlots: { customRender: 'name', filterDropdown: 'filterDropdownName' },
              width: 140,
              filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test19"></i></em>
            })
          } else if (value.sortId === 'all') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: { customRender: 'all' },
              width: 140
            })
          } else if (value.sortId === 'rectype') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: {
                customRender: 'rectype',
                filterDropdown: 'filterDropdown'
              },
              filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test20"></i></em>,
              onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  this.setIsTablePShow(true)
                } else {
                  this.setIsTablePShow(false)
                }
              },
              width: 160,
              ellipsis: true
            })
          } else {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId
            })
          }
        })
      }
      return tempArray
    },
    formateFilter (object) {
      const keys = Object.keys(object)
      const values = Object.values(object)
      const temp = []
      if (Array.isArray(keys)) {
        keys.map((value, index) => {
          let json = {
            text: values[index][0],
            value: value
          }
          temp.push(json)
        })
      }
      return temp
    },
    formateTableDatas (array, flag, maxPage) {
      let tempArray = []
      let tpadv = []
      let tempRowKeys = []
      if (Array.isArray(array)) {
        if (flag) {
          if (maxPage && maxPage <= 1) {
            tpadv = array.slice(1)
          } else {
            tpadv = array
          }
        } else {
          tpadv = array
        }
        tpadv.map((value, indexs) => {
          let json = {}
          json['key'] = 'rec' + Math.random()
          value.map((values, index) => {
            if (flag) {
              if (index === 0) {
                if (indexs === 0) {
                  if (maxPage && maxPage > 1) {
                    json[this.tablecolumnsArray[index]] = this.$t('message["177"]')
                  } else {
                    json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                  }
                } else {
                  json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                }
                json[this.tablecolumnsArray[index + 1]] = values
              } else {
                json[this.tablecolumnsArray[index + 1]] = values
              }
            } else {
              // json[this.tablecolumnsArray[index]] = values
              if (Array.isArray(values)) {
                const num = this.tablecolumnsArray.includes('rank') ? 2 : 1
                const columnsChildArray = JSON.parse(JSON.stringify(this.tablecolumnsArray)).splice(num)
                let tablechildDatas = []
                tablechildDatas = values.map((item) => {
                  let jsonchild = {}
                  item.forEach((val, index) => {
                    jsonchild[columnsChildArray[index]] = val
                    jsonchild['key'] = 'child' + Math.random()
                  })
                  return jsonchild
                })
                json['childTableData'] = values = tablechildDatas
                tempRowKeys.push(json['key'])
              } else {
                json[this.tablecolumnsArray[index]] = values
              }
            }
          })
          tempArray.push(json)
        })
      }
      return tempArray
    },
    /* 范围模块 */
    handleRangeRec (value, b) {
      delete this.overviewTimeData.roleid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.ismerge
      delete this.tendencyTimeData.roleid
      delete this.tendencyTimeData.groupid
      delete this.tendencyTimeData.userid
      delete this.tendencyTimeData.ismerge
      delete this.detailTimeData.roleid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.userid
      delete this.detailTimeData.ismerge
      if (value.length > 0) {
        // if (value[0] !== 'roleid-0') {
        value.map(item => {
          const array = item.split('-')
          const [name, key] = array
          this.overviewTimeData[name] = key
          this.tendencyTimeData[name] = key
          this.detailTimeData[name] = key
          if (b) {
            this.overviewTimeData['ismerge'] = 1
            this.tendencyTimeData['ismerge'] = 1
            this.detailTimeData['ismerge'] = 1
          }
        })
        // }
      }
      this.fetchGetRecOverView(this.overviewTimeData)
      this.fetchGetRTendencyDatas({ ...this.tendencyTimeData })
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 概览模块 */
    handleDateChangeRec (value) {
      this.$refs.revOverViewRef.initdDteSelectIndex()
      this.overviewTimeData.starttime = value[0]
      this.overviewTimeData.endtime = value[1]
      delete this.overviewTimeData.timetype
      this.fetchGetRecOverView(this.overviewTimeData)
    },
    /* 趋势模块 */
    handleDateChangeTendency (value) {
      this.$refs.revTendencyRef.initdDteSelectIndex()
      this.tendencyTimeData.starttime = value[0]
      this.tendencyTimeData.endtime = value[1]
      delete this.tendencyTimeData.timetype
      this.fetchGetRTendencyDatas({ ...this.tendencyTimeData })
    },
    /* 数据模块 - 日期选择事件 */
    handleDateChangeTableData (value) {
      this.$refs.revTableDataRef.initdDteSelectIndex()
      this.detailTimeData.starttime = value[0]
      this.detailTimeData.endtime = value[1]
      delete this.detailTimeData.timetype
      // this.developerTypeDefault = 0
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 概览模块 */
    handleCallbackEvent (val) {
      delete this.overviewTimeData.starttime
      delete this.overviewTimeData.endtime
      this.overviewTimeData.timetype = val.key
      this.fetchGetRecOverView(this.overviewTimeData)
    },
    /* 趋势模块 */
    handleCallbackTendencyEvent (val) {
      delete this.tendencyTimeData.starttime
      delete this.tendencyTimeData.endtime
      this.tendencyTimeData.timetype = val.key
      this.fetchGetRTendencyDatas({ ...this.tendencyTimeData })
    },
    /* 数据模块 - 今日/本周/本月/本年 切换事件 */
    handleCallbackDataEvent (val) {
      delete this.detailTimeData.starttime
      delete this.detailTimeData.endtime
      this.detailTimeData.timetype = val.key
      // this.developerTypeDefault = 0
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 趋势模块 */
    handleLevelChange (val) {
      if (val === '-1') {
        delete this.tendencyTimeData.level
      } else {
        this.tendencyTimeData.level = val
      }
      this.fetchGetRTendencyDatas({ ...this.tendencyTimeData })
    },
    /* 数据模块 */
    // 选择数据类型
    handleTypeChangeTableData (obj) {
      this.developerTypeDefault = obj.info_type
      this.detailTimeData = Object.assign(this.detailTimeData, obj)
      if (obj.info_type === 0) {
        this.$delete(this.detailTimeData, 'info_type')
      }
      if (!obj.info_sign) {
        this.$delete(this.detailTimeData, 'info_sign')
      }
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    // 信息来源筛选
    handleFromChange (val) {
      this.detailTimeData.from = val
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    setTabNavStyle () {
      this.$nextTick(() => {
        const tabNav = document.querySelector('#receptionOver .ant-tabs-nav-scroll')
        const alertTip = document.querySelector('#receptionOver .reception-tip-box')
        const $range = document.querySelector('#receptionOver .range-list')
        if (!tabNav || !alertTip || !$range) return
        const TabOffsetTop = alertTip.offsetTop + tabNav.parentNode.offsetHeight + 16

        tabNav.style.width = tabNav.parentNode.offsetWidth + 'px'
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        if (TabOffsetTop - this.$getScrollTop() >= 0) {
          tabNav.style.position = 'relative'
          $range.style.position = 'static'
          tabNav.style.left = 0
          tabNav.style.width = tabNav.parentNode.offsetWidth + 'px'
          $range.style.width = tabNav.parentNode.offsetWidth + 'px'
          this.fixed = false
        } else {
          this.fixed = true
          tabNav.style.position = 'fixed'
          $range.style.position = 'fixed'
          tabNav.style.width = tabNav.parentNode.offsetWidth + 'px'
          $range.style.width = tabNav.parentNode.offsetWidth + 'px'
          $range.style.top = 50 + 'px'
          tabNav.style.left = pageWidth <= sectionWidth ? alertTip.offsetLeft + 1 + 'px' : alertTip.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
          $range.style.left = pageWidth <= sectionWidth ? alertTip.offsetLeft + 1 + 'px' : alertTip.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.spin-css {
  position: absolute;
  top: 50%;
  left: 50%;
}
.role-select::v-deep {
  min-height: 56px !important ;
  .range-list{
     z-index: 1 !important;
  padding: 0 0 24px !important;
  }
.fixed-c {
   z-index: 1049 !important;
  padding: 16px 0 24px !important;
  border-bottom: 1px solid #ebebeb;
}
}

</style>
